import React, { useEffect, useContext } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import AuthContext from '../../context/authContext';
import { SCezardecrypt } from "../../myfunctions"
import { ConnectWS } from '../../ConnectWS';
import { Container, Segment } from 'semantic-ui-react';
import { lazy } from 'react';
import { lazyRetry } from '../../App';
import StartPage from './SinglePage/StartPage';

import Achievements from './Dashboard/ViewMembers/Achievements';
import Contact from './SinglePage/Other/Contact';
import PrivacyPolicy from './SinglePage/Other/PrivacyPolicy';
import Dashboard from './SinglePage/Dashboard';
import ShowActivities from './Dashboard/Activities/ShowActivities';
import StatueV2 from './SinglePage/Other/StatueV2';
import Error404Page from './SinglePage/ErrorPage/Error404Page';
import Faq from './SinglePage/Other/Faq';
import LoginNew from './Modal/LoginNew';
import PackagesGTL from './Dashboard/MyAccount/PackagesGTL';



/*


import ViewMembers from './Dashboard/ViewMembers/ViewMembers';
import Confirm from './SinglePage/Other/Confirm';
import ViewTurnament from './Dashboard/ViewMembers/ViewTurnament';
import ViewCycle from './Dashboard/ViewMembers/ViewCycle';
import PlayersStats from './Dashboard/ViewMembers/PlayersStats';
import Ranking from './SinglePage/Other/Ranking';
import MyTournamentExternal from './Dashboard/MyTournaments/MyTournamentExternal';

import KSPodwawelski from './DedicatedWebsite/KSPodwawelski';
import UKSKomorow from './DedicatedWebsite/UKSKomorow';

import MPWPP from './DedicatedWebsite/MPWPP/MPWPP';
import Griffinspin from './DedicatedWebsite/GRIFFINS/Griffinspin';
import DartRybnik from './DedicatedWebsite/DartRybnik';
import ViewDuelDart from './Dashboard/ViewMembers/ViewDuel/Dart/ViewDuelDart';
import Dart from './SinglePage/Other/Info/Dart';
import ViewDuelDartLobby from './Dashboard/ViewMembers/ViewDuel/Dart/ViewDuelDartLobby';
import Info from './SinglePage/Other/Info/Info';
import GriffinspinTreningi from './DedicatedWebsite/GRIFFINS/GriffinspinTreningi';
import ViewTournamentTv from './Dashboard/ViewMembers/ViewTournamentTv';

import TurniejGeneratorPrezentacja from './DedicatedWebsite/TurniejGeneratorPrezentacja';
import PlayersPossibleMerge from './Dashboard/ViewMembers/PlayersPossibleMerge';
import WidgetActivities from './Dashboard/Activities/WidgetActivities';
import WidgetSite from './DedicatedWebsite/WidgetSite';
import InfoTrening from './SinglePage/Other/Info/InfoTrening';
import WidgetTournament from './Dashboard/ViewMembers/WidgetTournament';
import WidgetSiteRouter from './DedicatedWebsite/WidgetSiteRouter';
import WidgetCycle from './Dashboard/ViewMembers/WidgetCycle';
import InfoLeague from './SinglePage/Other/Info/InfoLeague';


import PanelDash from '../../tools/SystemPanel/PanelDash';
import LoginPanel from '../../tools/SystemPanel/LoginPanel';
import MatchPanel from './Dashboard/ViewMembers/ViewDuel/MatchPanel/ViewDuelDart';
import TGPAsist from './SinglePage/Other/Info/TGPAsist';
*/



const lazyWithRetry = (importFunc) => lazy(() => lazyRetry(importFunc));

const WidgetActivities = lazyWithRetry(() => import('./Dashboard/Activities/WidgetActivities'));
const TGPAsist = lazyWithRetry(() => import('./SinglePage/Other/Info/TGPAsist'));
const PlayersPossibleMerge = lazyWithRetry(() => import('./Dashboard/ViewMembers/PlayersPossibleMerge'));
const TurniejGeneratorPrezentacja = lazyWithRetry(() => import('./DedicatedWebsite/TurniejGeneratorPrezentacja'));
const ViewTournamentTv = lazyWithRetry(() => import('./Dashboard/ViewMembers/ViewTournamentTv'));
const GriffinspinTreningi = lazyWithRetry(() => import('./DedicatedWebsite/GRIFFINS/GriffinspinTreningi'));
const Info = lazyWithRetry(() => import('./SinglePage/Other/Info/Info'));
const ViewDuelDartLobby = lazyWithRetry(() => import('./Dashboard/ViewMembers/ViewDuel/Dart/ViewDuelDartLobby'));
const Dart = lazyWithRetry(() => import('./SinglePage/Other/Info/Dart'));
const ViewDuelDart = lazyWithRetry(() => import('./Dashboard/ViewMembers/ViewDuel/Dart/ViewDuelDart'));
const DartRybnik = lazyWithRetry(() => import('./DedicatedWebsite/DartRybnik'));
const Griffinspin = lazyWithRetry(() => import('./DedicatedWebsite/GRIFFINS/Griffinspin'));
const MPWPP = lazyWithRetry(() => import('./DedicatedWebsite/MPWPP/MPWPP'));
const UKSKomorow = lazyWithRetry(() => import('./DedicatedWebsite/UKSKomorow'));
const KSPodwawelski = lazyWithRetry(() => import('./DedicatedWebsite/KSPodwawelski'));
const MyTournamentExternal = lazyWithRetry(() => import('./Dashboard/MyTournaments/MyTournamentExternal'));
const Ranking = lazyWithRetry(() => import('./SinglePage/Other/Ranking'));
const PlayersStats = lazyWithRetry(() => import('./Dashboard/ViewMembers/PlayersStats'));
const ViewCycle = lazyWithRetry(() => import('./Dashboard/ViewMembers/ViewCycle'));
const ViewTurnament = lazyWithRetry(() => import('./Dashboard/ViewMembers/ViewTurnament'));
const Confirm = lazyWithRetry(() => import('./SinglePage/Other/Confirm'));
const ViewMembers = lazyWithRetry(() => import('./Dashboard/ViewMembers/ViewMembers'));
const LoginPanel = lazyWithRetry(() => import('../../tools/SystemPanel/LoginPanel'));
const PanelDash = lazyWithRetry(() => import('../../tools/SystemPanel/PanelDash'));
const InfoLeague = lazyWithRetry(() => import('./SinglePage/Other/Info/InfoLeague'));
const WidgetCycle = lazyWithRetry(() => import('./Dashboard/ViewMembers/WidgetCycle'));
const WidgetSiteRouter = lazyWithRetry(() => import('./DedicatedWebsite/WidgetSiteRouter'));
const WidgetTournament = lazyWithRetry(() => import('./Dashboard/ViewMembers/WidgetTournament'));
const InfoTrening = lazyWithRetry(() => import('./SinglePage/Other/Info/InfoTrening'));
const WidgetSite = lazyWithRetry(() => import('./DedicatedWebsite/WidgetSite'));

const InfoAI = lazyWithRetry(() => import('./SinglePage/Other/Info/InfoAI'));
const InfoFIBA = lazyWithRetry(() => import('./SinglePage/Other/Info/InfoFIBA'));
const InfoPanelJudges = lazyWithRetry(() => import('./SinglePage/Other/Info/InfoPanelJudges'));
const InfoPanelMembers = lazyWithRetry(() => import('./SinglePage/Other/Info/InfoPanelMembers'));
const MatchPanel = lazyWithRetry(() => import('./Dashboard/ViewMembers/ViewDuel/MatchPanel/MatchPanel'));



function RouterPage(props) {
    const [auth, setAuth] = useAuth();// eslint-disable-line no-unused-vars
    //const { width } = useWindowDimensions();
    const authContext = useContext(AuthContext);// eslint-disable-line no-unused-vars
    useEffect(() => {
        checkUser()
        // showTawkMsg()
        return () => { }; // use effect cleanup to set flag false, if unmounted
    }, []);// eslint-disable-line react-hooks/exhaustive-deps


    /*
    function showTawkMsg() {
        if (window.location.href.indexOf('/iftg') > -1 || window.location.href.indexOf('/duel') > -1) {
          
        }else{
            var tawk = new TawkTo('65538f65958be55aeaaf94bd', '1hf76g9nd')
            tawk.onStatusChange((status) => {
                // console.log(status)
            })
        }
    }
    */


    const checkUser = () => {

        let token = window.localStorage.getItem('token');
        let gView = window.localStorage.getItem('gView');
        let tokenPanel = window.localStorage.getItem('tokenPanel');
        if (tokenPanel) {
            try {

                try {
                    let tmptoken = window.location.pathname.split("/")
                    if (tmptoken.length === 4) {
                        if (tokenPanel === tmptoken[4]) {
                            authContext.changeTokenPanel(tokenPanel)
                        } else {

                        }
                    }else{
                        authContext.changeTokenPanel(tokenPanel)
                    }

                } catch (e) {
                    authContext.changeTokenPanel(tokenPanel)
                }

            } catch (e) {
                console.log(e)
            }

        }
        if (gView) {
            try {
                authContext.changeView(JSON.parse(gView))
            } catch (e) {
                console.log(e)
            }

        }
        if (token) {
            try {
                let userInfo = JSON.parse(SCezardecrypt(window.localStorage.getItem('userInfo')));
                //authContext.changeUser(userInfo);
                //authContext.changeToken(token);       
                //setAuth(true, token, JSON.stringify(userInfo));
                ConnectWS("/login", null, { email: userInfo.email, password: userInfo.s }, function (response, logout) {

                    if (logout === 1) {
                        setAuth(false);
                    } else if (response && response.status && Number(response.status) === 200) {
                        userInfo = { ...userInfo, subscription_info: response.data.subscription_info, ai: response.data.AI }
                        authContext.changeUser(userInfo);
                        authContext.changeToken(response.data.token);
                        setAuth(true, response.data.token, JSON.stringify(userInfo));
                        console.log("AUTOLOGIN")
                    } else {

                    }
                });
            } catch (error) {
                console.error(error);

            }
        }


    }


    return (



        <Switch>

            <Route exact path="/regulamin"><StatueV2 /> </Route>
            <Route exact path="/polityka-prywatnosci"><PrivacyPolicy /> </Route>
            <Route exact path="/kontakt"><Contact /> </Route>
            <Route exact path="/rankingi"><Ranking /> </Route>
            <Route path="/osiagniecia/:achievementsId"><Achievements /></Route>

            <Route exact path="/panel">{authContext.tokenPanel ? <PanelDash /> : <Redirect to="/panel/login" />} </Route>
            <Route path="/panel/login/:jwtToken">{authContext.tokenPanel ? <Redirect to="/panel" /> : <LoginPanel />} </Route>
            <Route exact path="/panel/login">{authContext.tokenPanel ? <Redirect to="/panel" /> : <LoginPanel />} </Route>

            <Route exact path="/dashboard">{auth ? <Dashboard /> : <Redirect to="/" />} </Route>
            <Route exact path="/login">{auth && authContext.gView.myView && authContext.gView.myView.length > 4 ? <Redirect to="/dashboard" /> : <LoginNew />} </Route>
            <Route path="/tg/:tournamentIdCrc"><ViewMembers ver={1} /></Route>
            <Route exact path="/membermerge/:memberId/:memberName"><PlayersPossibleMerge /></Route>

            <Route path="/viewtv/:speedValueTmp/:tournamentIdCrc"><ViewTournamentTv ver={1} /></Route>
            <Route exact path="/activity/:activity_id"><ShowActivities ver={1} /></Route>
            <Route exact path="/widget/activity/:xkey"><WidgetActivities /></Route>
            <Route exact path="/widget/site/:xkey"><WidgetSite /></Route>
            <Route exact path="/widget/cycle/:xkey/:cycleId/:cycleName/:subtournamentName"><WidgetCycle /></Route>

            <Route path="/widget/v1/:xkey/:idt/:idst"><WidgetTournament /></Route>




            <Route path="/cykl/:cycleId/:cycleName/:subtournamentName"><ViewCycle /></Route>
            <Route path="/member/:id/:playerName"><PlayersStats /> </Route>
            <Route path="/tsv/:tournamentId/:subTournamentId"><ViewTurnament /></Route>

            <Route path="/et/:tournamentIdUP/:tokenUP"><MyTournamentExternal /></Route>
            <Route path="/match/panel/:jwttg"><MatchPanel /></Route>
            <Route path="/duel/dart/:jwttg"><ViewDuelDart /></Route>
            <Route path="/duel/lobby/dart/:idmatch/:idmember"><ViewDuelDartLobby /></Route>

            <Route exact path="/method/:methodname/:methodtoken"><Confirm /> </Route>

            <Route exact path="/faq"><Faq /> </Route>
            <Route exact path="/cennik"><Container><Segment><PackagesGTL /></Segment> </Container></Route>

            <Route exact path="/info/dart"><Dart /> </Route>
            <Route exact path="/info/system-ligowy"><InfoLeague /> </Route>
            <Route exact path="/info"><Info /> </Route>
            <Route exact path="/tg-pilkarski-asystent"><TGPAsist/> </Route>
            <Route exact path="/zapisy-na-treningi-online"><InfoTrening /> </Route>
            <Route exact path="/info/analiza-protokolow-meczowych-AI"><InfoAI /> </Route>
            <Route exact path="/info/analiza-protokolow-FIBA"><InfoFIBA /> </Route>
            <Route exact path="/info/zarzadzanie-pojedynkami-dla-sedziow-nominacje"><InfoPanelJudges /> </Route>
            <Route exact path="/info/zarzadzanie-pojedynkami-dla-zawodnikow-druzyn"><InfoPanelMembers /> </Route>
            

            <Route exact path={["/klub/:pagenamededicated", "/turnieje/:pagenamededicated", "/liga/:pagenamededicated"]}> <WidgetSiteRouter /> </Route>
            <Route exact path={["/kspodwawelski", "/podwawelski"]}><KSPodwawelski minHeightH={props.minHeightH} /> </Route>
            <Route exact path={["/komorow", "/komorów", "/ukskomorow", "/ukskomorów"]}> <UKSKomorow minHeightH={props.minHeightH} /> </Route>
            <Route exact path={["/mpwpp", "/gppwpp"]}> <MPWPP minHeightH={props.minHeightH} /> </Route>
            <Route path={["/griffinspin-treningi"]}> <GriffinspinTreningi minHeightH={props.minHeightH} /> </Route>
            <Route path={["/griffinspin"]}> <Griffinspin minHeightH={props.minHeightH} /> </Route>

            <Route path={["/prezentacja"]}> <TurniejGeneratorPrezentacja minHeightH={props.minHeightH} /> </Route>

            <Route path={["/dart-rybnik"]}> <DartRybnik minHeightH={props.minHeightH} /> </Route>
            <Route exact path="/404"> <Error404Page /> </Route>

            <Route exact path="/">{auth && authContext.gView.myView && authContext.gView.myView.length > 4 ? <Redirect to="/dashboard" /> : <StartPage />} </Route>

            <Route component={StartPage} />
        </Switch>

    )
}

export default RouterPage;